import {AsyncPipe, NgClass, NgStyle}    from '@angular/common';
import {Component, inject}              from '@angular/core';
import {FormsModule}                    from '@angular/forms';
import {DataAsstService}                from '../../../../logr-services/asst/data-asst.service';
import {PressHoldDirective}             from '../../../../logr-services/directives/press-hold.directive';
import {AsstSummarizerMessageComponent} from './asst-summarizer-message/asst-summarizer-message.component';

export interface AsstSummarizerResponse {
	loaded: number;
	partialText: string;
	type: number
}

@Component({
			   selector   : 'app-asst-summarizer',
			   imports: [
				   AsyncPipe,
				   FormsModule,
				   PressHoldDirective,
				   NgStyle,
				   NgClass,
				   AsstSummarizerMessageComponent
			   ],
			   templateUrl: './asst-summarizer.component.html',
			   styleUrl   : './asst-summarizer.component.css'
		   })
export class AsstSummarizerComponent {
	svcAsstData = inject(DataAsstService);


}
